<template>
  <div class="container">

    <Modal
      v-model="deleteRowModal"
      title="删除对账单"
      width="400"
      @on-ok="deleteDZD"
    >
      <div>确认要删除此条对账单吗？</div>
    </Modal>

    <Modal v-model="exportModal" title="筛选导出数据" class="select-export-receive" @on-visible-change="exportModalClose">
      <Form ref="exportItem" :model="exportItem" :rules="ruleValidate" label-position="top">
        <FormItem label="开始月份（选填）" prop="startMonth" class="export-item">
          <DatePicker type="month" v-model="exportItem.startMonth" placeholder="选择开始月份"></DatePicker>
        </FormItem>
        <FormItem label="结束月份（选填）" prop="endMonth" class="export-item">
          <DatePicker type="month" v-model="exportItem.endMonth" placeholder="选择结束月份"></DatePicker>
        </FormItem>
      </Form>
      <template #footer>
        <Button type="primary" @click="exportDuizhangdan('exportItem')">导出</Button>
      </template>
    </Modal>

    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索客户..."
          @on-change="searchCustomer"
          clearable
          icon="ios-search"
          style="width: 230px; margin-right: 20px"
        ></Input>
        <Select
            v-model="selectedCompany"
            clearable
            style="width: 150px; margin-right: 20px"
            @on-change="searchCustomer"
          >
            <Option
              v-for="option in companyList"
              :value="option._id"
              :key="option._id"
            >{{ option.abbr }}</Option>
          </Select>
          <div
            class="refresh"
            @click="loadDuiZhangDan(0)"
          >
            <Icon
              type="ios-refresh"
              size="24"
            />
          </div>
      </div>
      <div class="handle-right">
        <div class="page-wrap">
          <span>共{{ totalRows }}条</span>
          <Page
            :total="totalRows"
            :page-size="limit"
            @on-change="loadDuiZhangDan"
            show-total
            simple
            style="min-width: 160px"
          />
          
      </div>
      <Button
        type="default"
        style="margin-right: 8px;"
        @click="exportModal = true"
      >导出对账单</Button>
      <Button
        type="primary"
        style="margin-right: 8px;"
        @click="$refs.DuiZhangDanDrawerRef.openDrawer()"
      >新增对账单</Button>
    </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :columns="columns"
        :data="duizhangdanList"
        :height="tableHeight"
        :loading="tableLoading"
        border
      >
      <template slot-scope="{ row }" slot="operate">
        <div
          style="
            display: flex;
            justify-content: space-around;
            align-items: center;
          "
        >
          
          <Dropdown trigger="hover" @on-click="clickActionDropDown" transfer>
            <a>
              更多
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <div>
                <DropdownItem style="color: #ed4014" :name="`delete ${row._id}`">
                  删除此行
                </DropdownItem>
              </div>
            </DropdownMenu>
          </Dropdown>
        </div>
      </template>
    </Table>
    </div>

    <DuiZhangDanDrawer
      ref="DuiZhangDanDrawerRef"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
import axios from "@/utils/axios";
import DuiZhangDanDrawer from "./DuiZhangDanDrawer.vue";


export default {
  name: 'DuizhangdanListPage',
  components: { DuiZhangDanDrawer },
  data() {
    return {
      tableHeight: 300,
      searchText: null,
      selectedCompany: null,
      limit: 30,
      page: 0,
      filterQuery: {},
      tableLoading: false,
      deleteRowModal: false,
      exportModal: false,
      exportLoading: false,
      exportItem: {
        startMonth: null,
        endMonth: null,
      },
      ruleValidate: {
      },
      operateSelectedId: null,
      columns: [
        {
          title: "归属公司",
          key: "company",
          width: 100,
          render: (h, params) => {
            return h(
              "span",
              params.row.company.abbr
            );
          },
        },
        
        {
          title: "客户",
          key: "customer",
          width: 250,
          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  cursor: "pointer",
                  color: "#42b983",
                },
                on: {
                  click: () => {
                    this.$refs.DuiZhangDanDrawerRef.openDrawer(params.row);
                  },
                },
              },
              params.row.customer.name
            ),
        },
        {
          title: "开始日期",
          width: 110,
          key: "startDate",
          align: "left",
          render: (h, params) =>
            h("span", dayjs(params.row.startDate).format("YYYY-MM-DD")),
        },
        {
          title: "结束日期",
          width: 110,
          key: "endDate",
          align: "left",
          render: (h, params) =>
            h("span", dayjs(params.row.endDate).format("YYYY-MM-DD")),
        },
        {
          title: "欠款金额",
          key: "debtAmount",
          align: "right",
          width: 150,
          render: (h, params) => {
            return h(
              "span",
              Number(params.row?.debtAmount).toLocaleString(
                    "zh",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )
                || "-"
              
            );
          },
        },
        {
          title: "备注",
          key: "remark",
          minWidth: 150,
          align: "left",
          render: (h, params) => h("span", params.row.remark),
        },
        {
          title: "创建人",
          width: 100,
          key: "createdBy",
          align: "center",
          render: (h, params) =>
            h("span", params.row.createdBy?.name),
        },
        {
          title: "创建时间",
          minWidth: 110,
          key: "createdAt",
          align: "left",
          render: (h, params) =>
            h("span", dayjs(params.row.createdAt).format("YYYY-MM-DD")),
        },
        {
          title: "操作",
          key: "operate",
          slot: "operate",
          align: "center",
          fixed: "right",
          width: 150,
        },
        
      ]
    };
  },
  computed: mapState({
    duizhangdanList: (state) => state.duizhangdan.duizhangdanList,
    totalRows: (state) => state.duizhangdan.totalCounts,
    companyList: (state) => state.company.companyList,
  }),
  methods: {
    ...mapActions({
      getDuiZhangDan: "duizhangdan/getDuizhangdanAction",
      deleteDuiZhangDan: "duizhangdan/deleteDuizhangdanAction",
      getCompanyList: "company/getCompanyListAction",
    }),
    async loadDuiZhangDan(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
        company: this.selectedCompany
      };
      if (this.searchText) {
        this.filterQuery.cus_name = this.searchText;
      } else {
        delete this.filterQuery.cus_name;
      }
      try {
        this.tableLoading = true;
        await this.getDuiZhangDan(this.filterQuery)
        this.tableLoading = false;
      } catch (error) {
        
      }
    },
    searchCustomer: _.debounce(function () {
      this.page = 0;
      this.loadDuiZhangDan();
    }, 1000),
    async clickActionDropDown(name){
      const actionCode = name.split(" ")[0];
      this.operateSelectedId = name.split(" ")[1];

      switch (actionCode) {
        case "delete":
          this.deleteRowModal = true;
          break;
      }
    },
    async deleteDZD() {
      if (this.operateSelectedId) {
        await this.deleteDuiZhangDan(this.operateSelectedId);
        this.$Message.success("成功删除！");
        this.operateSelectedId = null;
      } else {
        this.$Message.error('没有选到id');
      }
    },
    exportModalClose(e) {
      if (!e) {
        this.exportLoading = false;
      }
    },
    async exportDuizhangdan(name) {
      if (this.exportItem.startMonth) {
        this.exportItem.startMonth = dayjs(this.exportItem.startMonth).format(
          "YYYY-MM"
        );
      }
      if (this.exportItem.endMonth) {
        this.exportItem.endMonth = dayjs(this.exportItem.endMonth).format(
          "YYYY-MM"
        );
      }
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          this.exportLoading = true;
          try {
            const res = await axios.get(`/duizhangdan_table`, {
              responseType: "blob",
              params: { ...this.exportItem },
            });
            const url = window.URL.createObjectURL(new Blob([res]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `对账单${dayjs().format("MM-DD-YYYY")}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            this.$Message.success("导出成功!");
            this.exportLoading = false;
            this.exportModal = false;
          } catch (error) {
            this.$Message.error({
              content: `导出失败!${error}`,
              closable: true,
              duration: 0,
            });
          }
        } else {
          this.$Message.error(`导出失败`);
        }
      });
    },
  },
  created() {
    this.loadDuiZhangDan();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
    this.getCompanyList({skip: 0, limit: 99});
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center
      min-width 220px

  .refresh
    cursor pointer

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>